import {
  SEND_DELIVERABLE_ALL,
} from './constants';

export function sendDeliverableAll(data, callback) {
  return {
    type: SEND_DELIVERABLE_ALL,
    data,
    callback,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/send-deliverable-all-modal/actions.js
 **/